import { CloudSecurityContext, RouteNameToApplicationContextMap } from "@/constants/general.ts";
import type { RouteName } from "@/constants/routes.ts";

export const getCloudSecurityContext = (routeName: RouteName): CloudSecurityContext => {
  return (
    RouteNameToApplicationContextMap[routeName] ?? CloudSecurityContext.CLOUD_SECURITY_POLICIES
  );
};
